export default "__VITE_ASSET__B0Ce6hQX__"